import type { ReactNode } from 'react';

import { Dropdown } from '#/components/Dropdown/Dropdown';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetJobsRoutePath } from '#/modules/search/jobs/routing/searchGetJobsRoutePath';

import { FindAJobDropdownMenu } from './FindAJobDropdownMenu';

type Props = {
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
  trackClickedContext: string;
};

const triggerTextByLocale: Record<I18nLocale, { text: string; href: string }> =
  {
    en: {
      text: 'Find a Job',
      href: searchGetJobsRoutePath({
        locale: I18nLocale.EN,
        embedSearchWidgetId: null,
      }),
    },
    es: {
      text: 'Encuentra empleo',
      href: searchGetJobsRoutePath({
        locale: I18nLocale.ES,
        embedSearchWidgetId: null,
      }),
    },
    pt: {
      text: 'Buscar Emprego',
      href: searchGetJobsRoutePath({
        locale: I18nLocale.PT,
        embedSearchWidgetId: null,
      }),
    },
  };

export function FindAJobDropdown({
  renderTrigger,
  trackClickedContext,
}: Props) {
  const { locale } = useI18n();
  const { text, href } = triggerTextByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText: text, triggerHref: href })}
      desktopTriggersOnHover
    >
      <FindAJobDropdownMenu trackClickedContext={trackClickedContext} />
    </Dropdown>
  );
}
